import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';

import CalenderModal from '../NoteModel/CalenderModal';
import ClassAddModal from './ClassManageModal/ClassAddModal';
import BreakTimeSettingModal from './ClassManageModal/BreakTimeSettingModal';
import ReservationLockModal from './ClassManageModal/ReservationLockModal';
import DailyClass from './DailyClass';
import FetchModule from '../../Share/Network/FetchModule';
import NewLessonLockAllModal from './ClassManageModal/NewLessonLockAllModal';
import WeeklyClassBox from './WeeklyClassBox';
import BreakTimeDeleteModal from './ClassManageModal/BreakTimeDeleteModal';
import NewClassDeleteModal from './ClassManageModal/NewClassDeleteModal';
import CoachFilterList from './CoachFilterList';

import LeftArrow from '../../../image/Left.png'//왼쪽 화살표
import RightArrow from '../../../image/Right.png'//우측 화살표
import CalenderBasic from '../../../image/calendarB.png'//캘린더 기본
import CalenderHover from '../../../image/calendarH.png'
import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import UndoIcon from '../../../image/UndoIcon.png';
import RedoIcon from '../../../image/RedoIcon.png';
import TodayButton from '../../../image/TodayButton.png'
import MonthClassDeleteModal from './ClassManageModal/MonthClassDeleteModal';


export default function ClassManageView() {
  const history = useHistory();
  const { t } = useLanguage();

  const [date, setDate] = useState(moment());
  const [clickDate, setClickDate] = useState(date.clone().format('YYYY.MM.DD'));
  const [rendering, setRendering] = useState(false);
  const [changedTeacherRendering, setChangedTeacherRendering] = useState(false);
  // const [dateList, setDateList] = useState([]);
  const [calenderClick, setCalenderClick] = useState(false);
  const [selectFormat, setSelectFormat] = useState('week');
  const [reserveClick, setReserveClick] = useState(false);
  const [useScheduleIndex, setUseScheduleIndex] = useState('-1');
  const [breakClick, setBreakClick] = useState(false);
  const [addClick, setAddClick] = useState(false);
  const [allReserveLockClick, setAllReserveLockClick] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [allReserveLock, setAllReserveLock] = useState(false);
  const [allReserveLockText, setAllReserveLockText] = useState(t('classManage.lockAll'));
  const [scheduleData, setScheduleData] = useState([]);
  const [useScheduleData, setUseScheduleData] = useState([]);
  // const [monthlyScheduleData, setMonthlyScheduleData] = useState([]);
  const [breakTimeData, setBreakTimeData] = useState([]);
  const [canceledSchedules, setCanceledSchedules] = useState([]);
  const [changedTeachers, setChangedTeachers] = useState([]);
  // const [reserveData, setReserveData] = useState([]);
  const [isClickedDelete, setIsClickedDelete] = useState(false);
  const [isClickedBreakTimeDelete, setIsClickedBreakTimeDelete] = useState(false);
  const [deletedData, setDeletedData] = useState(undefined);
  const [deletedBreakTimeData, setDeletedBreakTimeData] = useState(undefined);
  const [isClickedDeletedInDetailModal, setIsClickedDeletedInDetailModal] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [selectedCoaches, setSelectedCoaches] = useState([]); // 선택된 코치들

  const [isInProgress, setIsInProgress] = useState(false);
  const [lessonOptions, setLessonOptions] = useState([{ id: -1, name: t('classManage.selectOption'), time: 0, maxBookedPeople: 0 }]);
  const [lessonsWithTeachers, setLessonsWithTeachers] = useState([]); // teachers 정보 포함된 lessons
  const [isClickedDeleteMonth, setIsClickedDeleteMonth] = useState(false);

  const [isUndoHover, setIsUndoHover] = useState(false);
  const [isRedoHover, setIsRedoHover] = useState(false);

  // 스케줄 수정 및 삭제를 위한 변수
  const [scheduleId, setScheduleId] = useState(-1);

  // 수업 추가 모달 기본 세팅 변수 ( 수업추가 버튼이 아닌 빈 컬럼 눌렀을 경우 사용 ) //
  const [defaultClassTime, setDefaultClassTime] = useState('');
  const [defaultClassDate, setDefaultClassDate] = useState('');
  const [defaultApplyWeek, setDefaultApplyWeek] = useState('');

  const [standardDate, setStandardDate] = useState(moment().startOf('month'));

  // const [reserveDataReLoad, setReserveDataReLoad] = useState(false);

  const firstWeek = date.clone().startOf('month').week();
  const lastWeek = date.clone().endOf('month').week() === 1 ? 53 : date.clone().endOf('month').week();

  const CalenderButtonRef = useRef();
  const CalenderRef = useRef();

  useEffect(() => {
    let newDateList = [];

    for (let week = firstWeek; week <= lastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = date.clone().startOf('year').week(week).startOf('week').add(i, 'day');

        if (days.format('MM') === date.format('MM')) newDateList.push(days);
      }
    }
    
    setStandardDate(date.clone().startOf('month'));
    // setStandardDate(moment(date.format('YYYY.MM.01')));
    // setDateList(newDateList);
  }, [date, firstWeek, lastWeek])

  // Schedule Data API호출
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('schedule/', 'POST');
        if (responseData.status === 200) setScheduleData(responseData.data);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, rendering])

  // BreakTime Data API호출
  useEffect(() => {
    let requestData = {
      classDate: date.clone().format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('breaktime/', 'POST', requestData);

        if (responseData.status === 200) setBreakTimeData(responseData.data);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, rendering])

  // 폐강된 수업 데이터 불러오기 //
  useEffect(() => {
    let requestData = {
      startDate: date.clone().startOf('month').format('YYYY-MM-DDT00:00:00'),
      endDate: date.clone().endOf('month').format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/canceled', 'POST', requestData);

        if (responseData.status === 200) setCanceledSchedules(responseData.data.canceledSchedules);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, date])

  // 코치가 변경된 수업 데이터 불러오기 //
  useEffect(() => {
    let requestData = {
      startDate: date.clone().startOf('month').format('YYYY-MM-DDT00:00:00'),
      endDate: date.clone().endOf('month').format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('changed_teacher/', 'POST', requestData);

        if (responseData.status === 200) setChangedTeachers(responseData.data.changedTeachers);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, date, changedTeacherRendering])

  // 수업 데이터 받아오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('lesson/zone/schedule', 'GET');

        if (responseData.status === 200) {
          const lessons = responseData.data.lessons || [];
          const newOptions = [{ id: -1, name: t('classManage.selectOption') }, ...lessons];

          setLessonOptions(newOptions);
          setLessonsWithTeachers(lessons);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  // 코치 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('teacher/', 'GET');

        if (responseData.status === 200) {
          setTeachers(responseData.data.teachers);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  // Schedule 예약 전체 잠금상태에 따라 버튼 텍스트 변경
  useEffect(() => {
    if (allReserveLock) setAllReserveLockText(t('classManage.lockAll'));
    else setAllReserveLockText(t('classManage.unlockAll'))
  }, [allReserveLock])

  // 날짜 정리 //
  useEffect(() => {
    if (selectFormat === 'day') setClickDate(date.format('YYYY.MM.DD'));
  }, [date, selectFormat])

  function dateClick(value) {
    setClickDate(value);
    setDate(moment(value, 'YYYY.MM.DD'));

    if (calenderClick) CalenderRef.current.setValue(value);
  }

  function addButtonClick() {
    setAddClick(false);
    setRendering(!rendering);
    setDeletedData(undefined);
    setScheduleId(-1);

    setDefaultClassTime('');
    setDefaultClassDate('');
    setDefaultApplyWeek('');
  }

  function breakButtonClick() {
    setBreakClick(false);
    setRendering(!rendering);
  }

  function reservationButtonClick() {
    setReserveClick(false);
    setRendering(!rendering);
  }

  // 수업 상세정보 또는 주간 스케줄표 클릭시
  function onClickScheduleDetail(scheduleId, deletedData) {
    setDeletedData(deletedData);
    setScheduleId(scheduleId);
    setAddClick(true);
  }

  // 날짜 이전 버튼 클릭시 //
  function onClickPrevDate() {
    setDate(date.clone().subtract(1, selectFormat === 'week' ? 'month' : selectFormat));

    if (selectFormat === 'week') setIsLoading(true);
  }

  // 날짜 다음 버튼 클릭시 //
  function onClickNextDate() {
    setDate(date.clone().add(1, selectFormat === 'week' ? 'month' : selectFormat));

    if (selectFormat === 'week') setIsLoading(true);
  }

  // 시간표에서 빈칸 클릭시 //
  function onClickPlusColumn(classDate, classTime, applyWeek) {
    setDefaultClassDate(classDate);
    setDefaultClassTime(classTime);
    setDefaultApplyWeek(applyWeek);
    setClickDate(classDate);

    setAddClick(true);
  }

  // 수업 삭제모달 켜기 //
  function onClickDeleteButtonInComponent(data, division) {
    if (data.breakTimeId === undefined) {

      if (division === 'DetailModal') {
        setAddClick(false);
        setIsClickedDeletedInDetailModal(true);
        setIsClickedDelete(true);
      }
      else {
        setDeletedData(data);
        setIsClickedDelete(true);
      }
    }
    else {
      setDeletedBreakTimeData(data);
      setIsClickedBreakTimeDelete(true);
    }
  }


  // 수업 내역 삭제모달 안에서 삭제 클릭시 //
  function onClickOnlyOneDeleteClass() {
    if (deletedData === undefined) {
      alert(t('classManage.alertSelectSchedule'));
      return;
    }

    let requestData = {
      scheduleId: deletedData.scheduleId,
      changeApplyWeek: moment(deletedData.classDate, 'YYYY.MM.DD').format('ddd,'),
      deletedDate: moment(deletedData.classDate, 'YYYY.MM.DD').format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/delete/only_one', 'POST', requestData);

        if (responseData.status === 200) {
          setDeletedData(undefined);
          setIsClickedDelete(false);
          setRendering(!rendering);
          setAddClick(false);
          setScheduleId(-1);
          setIsClickedDeletedInDetailModal(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(t('classManage.alertDeleteFailed'));
          setIsClickedDelete(false);
          setIsClickedDeletedInDetailModal(false);
          return;
        }
      }
    )();

    setIsClickedDelete(false);
  }

  // 수업 내역 삭제모달 안에서 삭제 클릭시 //
  function onClickDeleteClass() {
    if (deletedData === undefined) {
      alert(t('classManage.alertSelectSchedule'));
      return;
    }

    let requestData = {
      scheduleId: deletedData.scheduleId,
      changeApplyWeek: moment(deletedData.classDate, 'YYYY.MM.DD').format('ddd,'),
      deletedDate: moment(deletedData.classDate, 'YYYY.MM.DD').format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/delete', 'POST', requestData);

        if (responseData.status === 200) {
          setDeletedData(undefined);
          setIsClickedDelete(false);
          setRendering(!rendering);
          setAddClick(false);
          setScheduleId(-1);
          setIsClickedDeletedInDetailModal(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(t('classManage.alertDeleteFailed'));
          setIsClickedDelete(false);
          setIsClickedDeletedInDetailModal(false);
          return;
        }
      }
    )();

    setIsClickedDelete(false);
  }

  // 삭제 경고 모달 닫기 버튼 클릭시 //
  function onClickDeleteModalClose() {
    if (isClickedDeletedInDetailModal) {
      setIsClickedDelete(false);
      setAddClick(true);
    }
    else {
      setDeletedData(undefined);
      setIsClickedDelete(false);
      setIsClickedDeletedInDetailModal(false);
    }
  }

  // 브레이크 타임 삭제 모달 내에서 삭제 클릭시 //
  function onClickDeleteBreakTime() {
    if (deletedBreakTimeData === undefined) {
      alert(t('classManage.alertSelectBreakTime'));
      return;
    }

    let requestData = {
      breakTimeId: deletedBreakTimeData.breakTimeId,
      changeApplyWeek: moment(deletedBreakTimeData.classDate, 'YYYY.MM.DD').format('ddd,'),
      deletedDate: moment(deletedBreakTimeData.classDate, 'YYYY.MM.DD').format('YYYY-MM-DDT00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('breaktime/delete', 'POST', requestData);

        if (responseData.status === 200) {
          setDeletedBreakTimeData(undefined);
          setIsClickedBreakTimeDelete(false);
          setRendering(!rendering);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();

    setIsClickedBreakTimeDelete(false);
  }

  // 브레이크 타임 삭제 경고 모달 내에서 닫기 버튼 클릭시 //
  function onClickDeleteBreakTimeModalClose() {
    setDeletedBreakTimeData(undefined);
    setIsClickedBreakTimeDelete(false);
  }

  // 수업 내역 삭제모달 안에서 돌아가기 클릭시 //
  function onClickExitDeleteMonth() {
    if (isInProgress) {
      alert(t('classManage.alertDeleteInProgress'));
      return;
    }

    setIsClickedDeleteMonth(false);
  }

  // 수업 내역 삭제모달 안에서 삭제 클릭시 //
  function onClickDeleteMonth() {
    if (isInProgress) {
      alert(t('classManage.alertDeleteInProgress'));
      return;
    }

    setIsInProgress(true);

    let requestData = {
      deletedDate: moment(date).format('YYYY-MM-01T00:00:00')
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/delete/month', 'POST', requestData);

        if (responseData.status === 200) {
          setIsClickedDeleteMonth(false);
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else {
          alert(t('classManage.alertDeleteFailed'));
          setIsClickedDeleteMonth(false);
          setIsInProgress(false);
        }
      }
    )();
  }

  // 언도 버튼 클릭시 //
  function onClickUndo() {
    if (isInProgress) {
      alert(t('classManage.alertUndoInProgress'));
      return;
    }

    setIsInProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/undo', 'POST');
        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else setIsInProgress(false);
      }
    )();
  }

  // 리도 버튼 클릭시 //
  function onClickRedo() {
    if (isInProgress) {
      alert(t('classManage.alertUndoInProgress'));
      return;
    }

    setIsInProgress(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('schedule/redo', 'POST');

        if (responseData.status === 200) {
          setRendering(!rendering);
          setIsInProgress(false);
        }
        else setIsInProgress(false);
      }
    )();
  }


  return (
    <TopLevelWrapper>
      {
        calenderClick &&
        <CalenderModal
          ref={CalenderRef}
          clickDate={clickDate}
          date={date}
          dateClickFn={dateClick}
          exitFn={setCalenderClick} />
      }
      {
        reserveClick &&
        <ReservationLockModal
          data={useScheduleData[useScheduleIndex]}
          cancel={() => reservationButtonClick()} />
      }
      {
        breakClick &&
        <BreakTimeSettingModal
          date={date}
          cancel={() => breakButtonClick()} />
      }
      {
        addClick &&
        <ClassAddModal
          date={moment(clickDate, 'YYYY.MM.DD')}
          scheduleData={scheduleData}
          scheduleId={scheduleId}
          onClickDeleteButton={onClickDeleteButtonInComponent}
          cancel={() => addButtonClick()}
          teachers={teachers}
          options={lessonOptions}
          clickedSchedule={deletedData}
          changedTeacherRendering={changedTeacherRendering}
          setChangedTeacherRendering={setChangedTeacherRendering}
          defaultClassTime={defaultClassTime}
          defaultClassDate={defaultClassDate}
          defaultApplyWeek={defaultApplyWeek} />
      }
      {
        allReserveLockClick &&
        <NewLessonLockAllModal
          allReserveLock={allReserveLock}
          useScheduleData={useScheduleData}
          rendering={rendering}
          setRendering={setRendering}
          cancel={() => setAllReserveLockClick(false)} />
      }
      {
        isClickedBreakTimeDelete &&
        <BreakTimeDeleteModal
          onClickExit={onClickDeleteBreakTimeModalClose}
          onClickDelete={onClickDeleteBreakTime} />
      }
      {
        isClickedDelete &&
        <NewClassDeleteModal
          deletedData={deletedData}
          onClickExit={onClickDeleteModalClose}
          onClickOnlyOneDelete={onClickOnlyOneDeleteClass}
          onClickAllDelete={onClickDeleteClass} />
      }

      {
        isClickedDeleteMonth &&
        <MonthClassDeleteModal
          isInProgress={isInProgress}
          deletedDate={date}
          onClickAllDelete={onClickDeleteMonth}
          onClickExit={onClickExitDeleteMonth} />
      }

      <TopBarWrapper>
        <TextWrapper>
          <Title>{t('classManage.title')}</Title>
          <Explanation>{t('classManage.desc')}</Explanation>
        </TextWrapper>
      </TopBarWrapper>
      <TopButtonWrapper>
        <LeftWrapper>
          <DateButtonWrapper>
            <ArrowWrapper onClick={onClickPrevDate} >
              <ArrowImage src={LeftArrow} />
            </ArrowWrapper>
            <DateText>
              {
                selectFormat === 'day' ?
                  date.clone().format(t('classManage.dateFormatDay'))
                  :
                  date.clone().format(t('classManage.dateFormatMonth'))
              }
            </DateText>
            <ArrowWrapper onClick={onClickNextDate}>
              <ArrowImage src={RightArrow} />
            </ArrowWrapper>
          </DateButtonWrapper>
        </LeftWrapper>
        <RightWrapper>
          <UndoRedoButton
            isHover={isUndoHover}
            onMouseOver={() => setIsUndoHover(true)}
            onMouseLeave={() => setIsUndoHover(false)}
            onClick={onClickUndo}>
            <UndoRedoImage src={UndoIcon} />
            <Text
              style={isUndoHover ?
                { visibility: 'visible', opacity: 1, whiteSpace: 'nowrap' }
                :
                { visibility: 'hidden', opacity: 0, whiteSpace: 'nowrap' }
              }
              fontFamily='NotoSansKR-Bold'
              fontSize={14}
              color='#FFFFFF'
              cursor='pointer'>{t('classManage.undoLabel')}</Text>
          </UndoRedoButton>
          <UndoRedoButton
            isHover={isRedoHover}
            onMouseOver={() => setIsRedoHover(true)}
            onMouseLeave={() => setIsRedoHover(false)}
            onClick={onClickRedo}>
            <UndoRedoImage src={RedoIcon} />
            <Text
              style={isRedoHover ?
                { visibility: 'visible', opacity: 1, whiteSpace: 'nowrap' }
                :
                { visibility: 'hidden', opacity: 0, whiteSpace: 'nowrap' }
              }
              fontFamily='NotoSansKR-Bold'
              fontSize={14}
              color='#FFFFFF'
              cursor='pointer'>{t('classManage.undoLabel')}</Text>
          </UndoRedoButton>
          <MonthlyDeleteButton onClick={() => setIsClickedDeleteMonth(true)}>
            <MonthlyDeleteImage src={WhiteTrashIcon} />
          </MonthlyDeleteButton>
          <ClassAddButton onClick={() => setAddClick(true)}>{t('classManage.addClass')}</ClassAddButton>
        </RightWrapper>
      </TopButtonWrapper>
      {
        selectFormat === 'week' && (
          <WeeklyViewWrapper>
            <CoachFilterList
              scheduleData={scheduleData}
              date={date}
              teachers={teachers}
              lessonsWithTeachers={lessonsWithTeachers}
              changedTeachers={changedTeachers}
              selectedCoaches={selectedCoaches}
              setSelectedCoaches={setSelectedCoaches}
            />
            <WeeklyClassBox
              rendering={rendering}
              setRendering={setRendering}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isInProgress={isInProgress}
              setIsInProgress={setIsInProgress}
              scheduleData={scheduleData}
              breakTimeData={breakTimeData}
              changedTeachers={changedTeachers}
              canceledSchedules={canceledSchedules}
              standardDate={standardDate}
              setClickDate={setClickDate}
              onClickDeleteButton={onClickDeleteButtonInComponent}
              onClickScheduleDetail={onClickScheduleDetail}
              onClickPlusColumn={onClickPlusColumn}
              selectedCoaches={selectedCoaches} />
          </WeeklyViewWrapper>
        )
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 42px;

  transition: all 0.3s ease-in-out;
`;

const TopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-left: 28px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #232323;

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 0 0 0;
`;

const TopButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-top: 38px;
  margin-bottom: 16px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const DateButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0 12px;

  width: 216px;
  height: 36px;

  border: 1px solid #DFDFDF;
  border-radius: 5px;
  background-color: #FFFFFF;
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 22px;
  height: 22px;

  &:hover { 
    cursor: pointer;
  }
`;

const ArrowImage = styled.img`
  display: flex;
  flex-direction: row;

  width: 9px;
  height: 15px;

  &:hover {
    cursor: pointer;
  }
`;

const ClassAddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;	
  height: 38px;

  border-radius: 10px;
  background-color: #6DD49E;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #2EAA69;
  }
`;

const DateText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #595959;

  margin: 0 0 0 0;
`;

const MonthlyDeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 38px;
  height: 38px;

  border-radius: 10px;
  background-color: #FF3131;

  opacity: 0.5;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }

  transition: all 0.3s ease-in-out;
`;

const MonthlyDeleteImage = styled.img`
  width: 24px;
  height: 24px;
`;

const UndoRedoButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.isHover ? `center` : `flex-start`};
  align-items: center;

  padding: 0px 10px;

  width: ${props => props.isHover ? '103px' : '18px'};
  height: 38px;

  border-radius: 10px;
  background-color: #CBCBCB;

  gap: 4px;

  overflow: hidden;

  &:hover {
    cursor: pointer;
    background-color: #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const UndoRedoImage = styled.img`
  width: 17px;
  height: 17px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const WeeklyViewWrapper = styled.div`

`;